import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap5';

import Select from 'components/new_ui/Select';
import { useContext as usePolicyPlansContext } from 'components/PolicyPlans/Context';
import { useContext } from 'components/Managers/Dashboard/Context';

export default function PolicyPlanFilter() {
  const { dispatch, actions, state: { filters } } = useContext();
  const {
    dispatch: dispatchPolicyPlans,
    actions: actionsPolicyPlans,
    state: statePolicyPlans,
  } = usePolicyPlansContext();

  useEffect(() => {
    actionsPolicyPlans.load(dispatchPolicyPlans);
  }, []);

  const policyPlansFilterOptions = statePolicyPlans.policyPlans && [
    {
      label: 'Active',
      options: statePolicyPlans.policyPlans.filter((plan) => plan.attributes.active).map(
        (policyPlan) => ({ label: policyPlan.attributes.name, value: policyPlan.id }),
      ),
    },
    {
      label: 'Inactive',
      options: statePolicyPlans.policyPlans.filter((plan) => !plan.attributes.active).map(
        (policyPlan) => ({ label: policyPlan.attributes.name, value: policyPlan.id }),
      ),
    },
  ];

  return (
    <Col>
      <div className="form-label">Plan</div>
      <Select
        id="policy-plan-id-filter"
        isMulti
        placeholder="All"
        isLoading={statePolicyPlans.policyPlans === null}
        options={policyPlansFilterOptions}
        onChange={(selectedOption) => actions.setPolicyPlanFilter(dispatch, filters, selectedOption)}
      />
    </Col>
  );
}
